module.exports = __webpack_public_path__ + "static/media/logo.9fea6935.png";